import { apiClient } from './client'
import type { ApiResponse } from './client'

export interface OtpRequestPayload {
  phone: string
}

export interface OtpVerifyPayload {
  phone: string
  code: string
}

export interface BriefingIntakeView {
  publicId: string
  sessionId: string | null
  sessionDate: string | null
  sessionMode: string | null
  applicationStatus: string
  receivedAt: string
}

export interface SessionChangePayload {
  /** 공개 회차 식별자(UUID) */
  sessionId: string
}

export async function requestOtp(payload: OtpRequestPayload) {
  const res = await apiClient.post<ApiResponse<{ expiresInSeconds: number }>>(
    '/lc-crm/public/otp/request',
    payload,
  )
  return res.data.data!
}

export async function verifyOtp(payload: OtpVerifyPayload) {
  const res = await apiClient.post<
    ApiResponse<{ sessionToken: string; expiresInSeconds: number }>
  >('/lc-crm/public/otp/verify', payload)
  return res.data.data!
}

export async function listMyBriefings(sessionToken: string) {
  const res = await apiClient.get<ApiResponse<BriefingIntakeView[]>>(
    '/lc-crm/public/my-briefings',
    { headers: { 'X-CRM-Session-Token': sessionToken } },
  )
  return res.data.data!
}

export async function changeSession(
  sessionToken: string,
  publicId: string,
  payload: SessionChangePayload,
) {
  const res = await apiClient.put<ApiResponse<BriefingIntakeView>>(
    `/lc-crm/public/my-briefings/${publicId}/session`,
    payload,
    { headers: { 'X-CRM-Session-Token': sessionToken } },
  )
  return res.data.data!
}

export async function cancelBriefing(
  sessionToken: string,
  publicId: string,
) {
  const res = await apiClient.post<ApiResponse<BriefingIntakeView>>(
    `/lc-crm/public/my-briefings/${publicId}/cancel`,
    {},
    { headers: { 'X-CRM-Session-Token': sessionToken } },
  )
  return res.data.data!
}
